import { Link } from 'react-router-dom';
import { DISCOVERY_CONTEXTS } from '../../data/discoveryContexts';

/**
 * DiscoveryPortal renders the eight CHIMERA discovery contexts as the
 * substrate-anchor surface immediately below the hero. Each tile routes
 * to /discover?context=<id> which auto-triggers that context's query.
 *
 * Pair: viewer-and-substrate-bearing-film-discovery. The Home entry rhythm.
 */
export default function DiscoveryPortal() {
  return (
    <section className="px-4 sm:px-6 lg:px-12">
      <div className="mb-3 flex flex-wrap items-baseline justify-between gap-3">
        <div>
          <p className="text-[10px] font-semibold uppercase tracking-[0.28em] text-emerald-300/80">
            CHIMERA Discovery
          </p>
          <h2 className="mt-1 text-xl font-semibold text-white sm:text-2xl">
            Pick a body signal
          </h2>
        </div>
        <Link
          to="/discover"
          className="text-xs uppercase tracking-[0.2em] text-emerald-200/70 hover:text-emerald-100"
        >
          Open Discover →
        </Link>
      </div>

      <div className="grid grid-cols-2 gap-3 sm:grid-cols-3 lg:grid-cols-4">
        {DISCOVERY_CONTEXTS.map((context) => (
          <Link
            key={context.id}
            to={`/discover?context=${context.id}`}
            className="group flex flex-col gap-1 rounded-2xl border border-emerald-300/15 bg-black/30 p-4 transition hover:border-emerald-300/45 hover:bg-emerald-300/[0.04]"
          >
            <span className="text-2xl" aria-hidden="true">{context.icon}</span>
            <span className="text-sm font-semibold text-white">{context.label}</span>
            <span className="text-xs leading-snug text-gray-400 group-hover:text-gray-200">
              {context.description}
            </span>
          </Link>
        ))}
      </div>
    </section>
  );
}
